import clonedeep from 'lodash/fp/cloneDeep'
import pick from 'lodash/fp/pick'
import merge from 'lodash/fp/merge'
import isEqual from 'lodash/fp/isEqual'
import debounce from 'lodash/fp/debounce'

export default {
    cloneDeep: clonedeep,
    pick: pick,
    merge: merge,
    isEqual: isEqual,
    debounce: debounce,
};


